import { Link, Stack } from '@chakra-ui/react';
import { Text } from '@diamond/shared/ui';
import { buildNlbTermsHref } from '@diamond/sol-buyer/utils';
import NextLink from 'next/link';

export function PaymentInfoNotes() {
  return (
    <Stack spacing={2}>
      <Text fontSize={{ base: 'xs', md: 'sm' }} color="gray.700">
        Update nominal 1x24 jam setelah PO diproses. Nominal Lebih Bayar karena
        perubahan stok sebagian akan tampil ± 3–5 hari kerja setelah pesanan
        selesai.
      </Text>
      <Link
        as={NextLink}
        href={buildNlbTermsHref()}
        color="blue"
        fontSize={{ base: 'xs', md: 'sm' }}
        fontWeight="medium"
        _hover={{ textDecoration: 'underline' }}
      >
        Syarat dan Ketentuan Nominal Lebih Bayar
      </Link>
    </Stack>
  );
}
